import React, { useCallback, useEffect, useRef, useState } from "react";
import { columns, searchBy } from "../../../service/AUSubcategoryService";
// import BasicTable from "../../../Components/CommonTable/BasicTable/BasicTable";
// import StoreModal from "../../../Components/Modals/StoreModal/StoreModal";
// import ReferralModal from "../../PromotionManagement/Refferal/ReferralModal";

import { toast } from "react-toastify";
import BasicTable from "../../../components/Table/BasicTable";
import { SubCategoryApi } from "../../../apis/menu.apis";
import { ApproveUnapproveApi } from "../../../apis/a&uApi";

const AUSubcategoryComponent = ({ pagination, handlePagination }) => {
  const [search, setSearch] = useState("");
  const debounceTimeout = useRef(null);
  const [isOrderDetail, setIsOrderDetail] = useState(false);
  const [selectedOrder, setSelectedSubcategory] = useState(null);
  const [vendorData, setVendorData] = useState(null);
  const [subcategoryData, setPromocodeData] = useState(null);

  const getAllSubcategory = async () => {
    try {
      const res = await SubCategoryApi.getSubCategory(pagination, search);
      setPromocodeData(res?.data?.data);
    } catch (error) {
      toast.error(error?.message);
    }
  };

  const handleCloseOrderModal = () => {
    setIsOrderDetail(false);
    setSelectedSubcategory(null);
  };
  const handleRowClick = (row) => {
    setSelectedSubcategory(row);
    setIsOrderDetail(true);
  };
  const handleCellClick = async (row, action) => {
    if (action === "Approved" || action === "Unapproved") {
      try {
        await ApproveUnapproveApi.updateSubCategoryApprovalStatus(row?._id, {
          status: action,
        });
        getAllSubcategory();
      } catch (error) {
        toast.error(error?.message);
      }
    }
  };

  const onPaginatorClick = (e) => {
    if (e) {
      const data = {
        limit: e.rows,
        page: +e.page + 1,
      };
      handlePagination && handlePagination(data);
    }
  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  const handleClearFilter = () => {
    const clearPagination = {
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    };
    handlePagination && handlePagination({ clearPagination });
  };
  const handleFilter = (name, value) => {
    let data = {};
    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
    }

    handlePagination && handlePagination(data);
  };

  useEffect(() => {
    getAllSubcategory();
  }, [pagination, search]);

  return (
    <div className="p-5">
      <BasicTable
        // data={[]}

        columns={columns}
        data={subcategoryData?.subcategories}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: subcategoryData?.limit || 5,
          sortField: null,
          sortOrder: null,
          totalPages: subcategoryData?.totalPages || 1,
          totalCount: subcategoryData?.totalCount || 1,
        }}
        onCellClick={(e) => {
          console.log("Cell Data", e);
        }}
        SearchBy={searchBy}
        handleSearch={debouncedSearch}
        handleFilter={(name, value) => handleFilter(name, value)}
        handleClearFilter={handleClearFilter}
        // filters={filters}
        selectedData={selectedOrder}
        handleCellClick={handleCellClick}
      />
      {/* <ReferralModal
        handleRowClick={handleRowClick}
        isOrderDetail={isOrderDetail}
        handleCloseOrderModal={handleCloseOrderModal}
        referralData={selectedOrder}
      />
      <StoreModal
        itemData={vendorData}
        setToggleUsersDetails={(v) => {
          setVendorData(null);
        }}
        toggleUsersDetails={Boolean(vendorData)}
      /> */}
    </div>
  );
};

export default AUSubcategoryComponent;
